import styled, { keyframes } from 'styled-components'

// 定义动画关键帧
const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 1; }
`

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  background: #fff;
`

const SVGWrapper = styled.div`
  width: 120px;
  height: 120px;
  position: relative;
  animation: ${float} 3s ease-in-out infinite;
`

const CoreCircle = styled.circle`
  fill: #ff7a45;
  animation: ${pulse} 2s ease-in-out infinite;
`

const OrbitPath = styled.circle`
  fill: none;
  stroke: #ffd8cc;
  stroke-width: 2;
`

const OrbitingDot = styled.circle`
  fill: #ff4d4f;
  animation: ${rotate} 3s linear infinite;
  transform-origin: 60px 60px;
`

const Text = styled.p`
  margin-top: 24px;
  color: #666;
  text-align: center;
  line-height: 1.6;
`

export const LoadingView = () => {
  return (
    <Container>
      <SVGWrapper>
        <svg width="120" height="120" viewBox="0 0 120 120">
          {/* 外圈轨道 */}
          <OrbitPath cx="60" cy="60" r="50" />

          {/* 中心圆形 */}
          <CoreCircle cx="60" cy="60" r="20">
            <animate attributeName="r" values="20;22;20" dur="2s" repeatCount="indefinite" />
          </CoreCircle>

          {/* 围绕中心旋转的小点 */}
          <g>
            <OrbitingDot cx="110" cy="60" r="6" />
            <OrbitingDot cx="110" cy="60" r="6" transform="rotate(120 60 60)" />
            <OrbitingDot cx="110" cy="60" r="6" transform="rotate(240 60 60)" />
          </g>

          {/* 装饰性光芒 */}
          <path d="M60 10 L60 0 M60 120 L60 110 M10 60 L0 60 M120 60 L110 60" stroke="#FFD8CC" strokeWidth="2" />
        </svg>
      </SVGWrapper>
      <Text>
        Creavo is crafting something amazing...
        <br />
        This might take a moment
      </Text>
    </Container>
  )
}
